import { IOptions } from '@acorn-portal/shared/src/components/inputs/select';

const getClosestMileage = (mileages: IOptions[], targetNumber?: number): string => {
	if (targetNumber === undefined || targetNumber === 0 || Number.isNaN(targetNumber)) return '';

	let closestMileage: IOptions = {
		value: 1000,
		label: '0 - 1000',
	};

	const target = Math.ceil(targetNumber / 1000) * 1000;

	for (let index = 0; index < mileages.length; index += 1) {
		const mileage = mileages[index];
		const value = mileage.value as number;

		if (value === target) {
			closestMileage = mileage;
		}
	}

	const maxMileage = Math.max(...mileages.map((m) => m.value as number));

	if (targetNumber >= maxMileage) {
		return maxMileage.toString();
	}

	return closestMileage.value as string;
};

export default getClosestMileage;
